export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13972.c38aca8d.jpg";